export enum LocalStorageRegistry {
  realEstate = 'hasDismissedRealEstateMapSrpCTA',
  registration = 'hasDismissedRegistrationCTA',
  USER_ADJUSTED_RADIUS = 'uar',
  USER_LAST_RADIUS_VALUE = 'ulr',
  RECENT_LOCATIONS = 'RecentSearchLocations',
}
